import React, { useEffect, useState } from 'react'
import { CloseCircle, TickCircle } from 'iconsax-react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import {
  GET_SETUP_INTENT_ASYNC,
  UNSUBSCRIBE_COMPLETE_COPY,
} from 'containers/Settings/CreditsManagement/constants'
import {
  selectSetupIntentError,
  selectSetupIntentLoader,
} from 'containers/Settings/CreditsManagement/selectors'

import Button from 'components/lib/DesignSystem/V3/Button'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 360px;
  padding: 16px;
  background: var(--color-elevated);
  border: 2px solid var(--primary);
  border-radius: var(--t-border-radius-xl, 16px);
  box-shadow: var(--color-elevated-shadow);
  color: var(--color-text);
`

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--primary);
`

const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--color-text);
`

const BodyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--color-text);
`

const CloseButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--primary);
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
    border-radius: 2px;
  }
`

// Resubscribe goes straight to Stripe's "Continue to payment" screen; the
// redirect is done by the setup-intent epic (`redirect: true`) so it survives
// this toast auto-dismissing while the request is in flight.
const UnsubscribeCompleteToast = ({ onClose, id = 'billing-unsubscribe-complete-toast' }) => {
  const dispatch = useDispatch()
  const loader = useSelector(selectSetupIntentLoader)
  const error = useSelector(selectSetupIntentError)
  const [requested, setRequested] = useState(false)

  useEffect(() => {
    if (error) setRequested(false)
  }, [error])

  const handleResubscribe = () => {
    setRequested(true)
    dispatch(GET_SETUP_INTENT_ASYNC.initiate({ redirect: true }))
  }

  return (
    <Card id={id} role="status" aria-live="polite">
      <TopRow>
        <TitleGroup>
          <TickCircle size={20} variant="Bold" />
          <Title>{UNSUBSCRIBE_COMPLETE_COPY.title}</Title>
        </TitleGroup>
        <CloseButton type="button" aria-label="Close" onClick={onClose}>
          <CloseCircle size={16} />
        </CloseButton>
      </TopRow>
      <BodyRow>
        <Body>{UNSUBSCRIBE_COMPLETE_COPY.body}</Body>
        <Button
          id="billing-resubscribe"
          variant="primary"
          size="small"
          loading={requested && loader}
          disabled={requested && loader}
          onClick={handleResubscribe}
        >
          {UNSUBSCRIBE_COMPLETE_COPY.cta}
        </Button>
      </BodyRow>
    </Card>
  )
}

export default UnsubscribeCompleteToast
